import React from 'react'
import { Box, Typography, Slider, Stack } from '@mui/material'

const SliderField = ({ name, label, min = 0, max = 100, step = 1, value, onChange, icon: Icon, unit = '', disabled = false }) => {
  const marks = []
  const markStep = max <= 100 ? 25 : max <= 500 ? 100 : 1000
  for (let i = min; i <= max; i += markStep) {
    marks.push({ value: i, label: `${i}` })
  }

  return (
    <Box>
      <Stack direction="row" justifyContent="space-between" alignItems="center" mb={1}>
        <Stack direction="row" alignItems="center" spacing={1}>
          {Icon && <Icon sx={{ fontSize: 20, color: 'primary.main' }} />}
          <Typography variant="body2" fontWeight={500}>{label}</Typography>
        </Stack>
        <Typography variant="h5" fontWeight={700} color="primary.main">
          {value ?? min}{unit}
        </Typography>
      </Stack>
      <Slider
        name={name}
        value={value ?? min}
        onChange={(_, val) => onChange(name, val)}
        min={min}
        max={max}
        step={step}
        marks={marks}
        valueLabelDisplay="auto"
        disabled={disabled}
        sx={{
          '& .MuiSlider-markLabel': { fontSize: '0.7rem', color: 'text.secondary' },
          '& .MuiSlider-thumb': { width: 24, height: 24 },
        }}
      />
    </Box>
  )
}

export default SliderField
